import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import AssetLoadService from "../../app/assetloading/AssetLoadService";
import AssetLoadServiceEvent from "../../app/assetloading/AssetLoadServiceEvent";
import AppModel from "../../app/core/AppModel";
import PlayMode from "../model/PlayMode";

export default class InitPlayModeTask extends Task {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {AssetLoadService} assetLoadService 
     * @param {AppModel} appModel 
     */
    constructor(dispatcher, assetLoadService, appModel) {
        super();

        this.execute = function(callback, progressCallback) {

            const playMode = appModel.playMode;
            console.log("InitPlayModeTask, playmode: ", playMode);
            const assetGroupId = "language_" + playMode;
            if (playMode == PlayMode.ASSESSMENT || assetLoadService.getManifest(assetGroupId)==null) {
                callback(this);
                return;
            }
            //Load playmode specific language
            //replace languagepack entries with playmode variants
            dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, () => {
                callback(this);
            });
            assetLoadService.loadGroups(assetGroupId);
        }
    }

}
